import React from "react";
import PropTypes from "prop-types";
import CorrectIcon from "@common/images/correct-icon.svg";
import IncorrectIcon from "@common/images/incorrect-icon-light.svg";
import { Image, Colours } from "@learningblocks/shared-components";
import className from "./style.module.scss";

/**
 * TestTubeFeedback
 *  - The component that displays the feedback for LabelTestTube
 */
export function TestTubeFeedback(props) {
  const renderMessage = () =>
    props.message ? (
      <p
        className={className.feedback_message}
        style={{
          color: props.isCorrect
            ? Colours.colorFeedbackSuccessTint40
            : Colours.colorFeedbackFailTint40,
        }}
      >
        {props.message}
      </p>
    ) : null;

  if (props.showFeedback) {
    let src = IncorrectIcon;
    if (props.isCorrect) {
      src = CorrectIcon;
    }
    return (
      <div className={`${className.feedback} ${props.className}`}>
        <Image
          className={className.feedback_icon}
          src={src}
          alt="feedback-icon"
        />
        {renderMessage()}
      </div>
    );
  } else {
    return null;
  }
}

TestTubeFeedback.propTypes = {
  /**
   * className to set on feedback-wrapper
   */
  className: PropTypes.string,
  /**
   * Boolean value to display/hide the feedback
   */
  showFeedback: PropTypes.bool.isRequired,
  /**
   * Boolean specifying if submitted answer correct.
   */
  isCorrect: PropTypes.bool,
  /**
   * Message to display for feedback
   */
  message: PropTypes.string,
};

TestTubeFeedback.defaultProps = {
  className: "tube-feedback",
  message: "",
  showFeedback: false,
};
